import { render } from "./EzerSuggestions.vue?vue&type=template&id=86085e76"
import script from "./EzerSuggestions.vue?vue&type=script&lang=js"
export * from "./EzerSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__